import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const LinkedInIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.7275 0C7.89087 0 0.727539 7.38719 0.727539 16.5C0.727539 25.6128 7.89087 33 16.7275 33C25.5642 33 32.7275 25.6128 32.7275 16.5C32.7275 7.38719 25.5642 0 16.7275 0ZM12.8109 23.3389H9.57087V12.5864H12.8109V23.3389ZM11.1709 11.2664C10.1475 11.2664 9.48587 10.5187 9.48587 9.59406C9.48587 8.65047 10.1675 7.92516 11.2125 7.92516C12.2575 7.92516 12.8975 8.65047 12.9175 9.59406C12.9175 10.5187 12.2575 11.2664 11.1709 11.2664ZM24.6442 23.3389H21.4042V17.38C21.4042 15.993 20.9342 15.0511 19.7625 15.0511C18.8675 15.0511 18.3359 15.6888 18.1009 16.3023C18.0142 16.5206 17.9925 16.83 17.9925 17.1377V23.3372H14.7509V16.0153C14.7509 14.673 14.7092 13.5506 14.6659 12.5847H17.4809L17.6292 14.0783H17.6942C18.1209 13.377 19.1659 12.3423 20.9142 12.3423C23.0459 12.3423 24.6442 13.8153 24.6442 16.9812V23.3389Z"
        fill="currentColor"
      />
    </svg>
  </StyledSvgIcon>
);
export default LinkedInIcon;

LinkedInIcon.propTypes = customIconsPropTypes;
